module.exports = __webpack_public_path__ + "img/Tidak Bergerak.3bd7bfb3.svg";